import React from 'react';
import { string, bool } from 'prop-types';
import { LazyExpertModal } from '@fiverr-private/experts';

export const ExpertModal = ({ username, translationFlag, children }) => (
    <LazyExpertModal username={username}
        source={LazyExpertModal.Sources.GigPage}
        translationFlag={translationFlag}
        fallbackChildren>
        {children}
    </LazyExpertModal>
);

ExpertModal.propTypes = {
    username: string.isRequired,
    translationFlag: bool
};
